import script from "./MobileNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "./MobileNumberInput.vue?vue&type=style&index=0&id=50e70dbc&lang=css"

const __exports__ = script;

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon});
